import { PresentationSettings } from 'messages/websocket.messages';

import { UserId } from '../../types';

export enum SubscriptionType {
  PARTICIPANT = 'PARTICIPANT',
  SCREEN_SHARE = 'SCREEN_SHARE',
  MIRROR = 'MIRROR',
  LIVE_STREAM = 'LIVE_STREAM',
  MIX = 'MIX',
}

export enum SubscriptionReason {
  AUDIBLE,
  VISIBLE,
  GROUP,
  GROUP_SHARE,
  AUDIENCE,
  GALLERY,
  SPEAKING,
  SCREEN_SHARE,
  MIRROR,
  LIVESTREAM,
  PRESENTER,
  MIX,
}

// Higher number means higher priority
export const REASON_PRIORITY: Record<SubscriptionReason, number> = {
  [SubscriptionReason.AUDIBLE]: 0,
  [SubscriptionReason.VISIBLE]: 1,
  [SubscriptionReason.GROUP]: 2,
  [SubscriptionReason.GROUP_SHARE]: 3,
  [SubscriptionReason.AUDIENCE]: 4,
  [SubscriptionReason.GALLERY]: 5,
  [SubscriptionReason.SPEAKING]: 6,
  [SubscriptionReason.SCREEN_SHARE]: 7,
  [SubscriptionReason.MIRROR]: 8,
  [SubscriptionReason.LIVESTREAM]: 9,
  [SubscriptionReason.PRESENTER]: 10,
  [SubscriptionReason.MIX]: 11,
};

export type SubscriptionSettings = Record<SubscriptionReason, { audioRequired: boolean; videoRequired: boolean }>;

export interface SubscriberState {
  audioRequired: boolean;
  reason: SubscriptionReason;
  videoRequired: boolean;
  id: string;
  distance?: number;
}
export interface GroupUser {
  userId: UserId;
  visible: boolean;
}

export interface DistanceUser {
  userId: string;
  distance: number;
}

export interface AudibleUser {
  userId: string;
  volume: number;
}

export const SUBSCRIPTION_SETTINGS: SubscriptionSettings = {
  [SubscriptionReason.PRESENTER]: {
    audioRequired: true,
    videoRequired: true,
  },
  [SubscriptionReason.AUDIENCE]: {
    audioRequired: true,
    videoRequired: true,
  },
  [SubscriptionReason.SPEAKING]: {
    audioRequired: true,
    videoRequired: true,
  },
  [SubscriptionReason.VISIBLE]: {
    audioRequired: true,
    videoRequired: true,
  },
  [SubscriptionReason.AUDIBLE]: {
    audioRequired: true,
    videoRequired: false,
  },
  [SubscriptionReason.MIX]: {
    audioRequired: true,
    videoRequired: false,
  },
  [SubscriptionReason.SCREEN_SHARE]: {
    audioRequired: false,
    videoRequired: true,
  },
  [SubscriptionReason.MIRROR]: {
    audioRequired: true,
    videoRequired: true,
  },
  [SubscriptionReason.GROUP]: {
    audioRequired: true,
    videoRequired: true,
  },
  [SubscriptionReason.GALLERY]: {
    audioRequired: false,
    videoRequired: true,
  },
  [SubscriptionReason.GROUP_SHARE]: {
    audioRequired: true,
    videoRequired: true,
  },
  [SubscriptionReason.LIVESTREAM]: {
    audioRequired: true,
    videoRequired: true,
  },
};

export interface SubscriptionOptions {
  isAudioMixed: boolean;
  isUserPresenting: boolean;
  isPresentationActive: boolean;
  isToastActive: boolean;
  speakingParticipantsV1: boolean;
  presentationSettings: PresentationSettings | undefined;
  unrestrictedZoom: boolean;
  isUserInGroupShare: boolean;
}

export const SUBSCRIPTION_LIMIT = 1000;
export const VISIBLE_SUBSCRIPTIONS_LIMIT = 20;
export const DEFAULT_SUBSCRIPTION_LIMIT = 20;
export const SPEAKING_SUBSCRIPTION_LIMIT = 4;
export const PLAYERS_IN_VIEW_INTERVAL = 2500;
